
/* ============================================================
   AV-99: Alia Promo Modal Accessibility JS Overrides
   Injected by Melinda's Accessibility Tool
   ============================================================ */
(function() {
  'use strict';

  // Emergency rollback: keep the simpler modal override active until the
  // April 2026 hardening block is rewritten without observer feedback loops.

  var MODAL_SELECTORS = '[data-alia-modal], .alia-popup, .alia-modal, [id^="alia-root-"], [id^="alia-popup-root-"], [role="dialog"][aria-label*="Alia"]';

  function isLikelyDialog(modal) {
    if (!modal || modal.offsetParent === null) return false;

    var rect = modal.getBoundingClientRect ? modal.getBoundingClientRect() : { width: 0, height: 0 };
    var hasFormControl = !!modal.querySelector('form, input:not([type="hidden"]), select, textarea');
    var hasHeading = !!modal.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"], [class*="title"], [class*="heading"], [class*="headline"]');
    var hasCloseControl = !!modal.querySelector('[class*="close"], [aria-label*="close"], [aria-label*="Close"]');
    var text = ((modal.textContent || '').replace(/\s+/g, ' ')).trim();
    var hasLongCopy = text.length > 80;
    var hasDialogSize = rect.width >= 280 || rect.height >= 180;

    return hasFormControl || hasHeading || (hasDialogSize && hasCloseControl) || (hasDialogSize && hasLongCopy);
  }

  function canRestoreFocus(target, modal) {
    return !!(
      target &&
      target !== document.body &&
      typeof target.focus === 'function' &&
      document.contains(target) &&
      (!modal || !modal.contains(target))
    );
  }

  function getModal() {
    var modals = document.querySelectorAll(MODAL_SELECTORS);
    for (var i = 0; i < modals.length; i += 1) {
      if (isLikelyDialog(modals[i])) return modals[i];
    }
    return null;
  }

  function fixModalA11y(modal) {
    if (!modal || modal.dataset.a11yFixed) return;
    modal.dataset.a11yFixed = 'true';
    modal.setAttribute('data-a11y-promo-dialog', 'true');

    // 1. Set ARIA role and attributes
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    // Find or set a label
    var heading = modal.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"], [class*="title"], [class*="heading"], [class*="headline"]');
    if (heading) {
      if (!heading.id) heading.id = 'alia-modal-title';
      modal.setAttribute('aria-labelledby', heading.id);

      // Fix heading hierarchy — ensure it's an h2 inside modal
      if (heading.tagName !== 'H2') {
        heading.setAttribute('role', 'heading');
        heading.setAttribute('aria-level', '2');
      }
    } else {
      modal.setAttribute('aria-label', 'Promotional offer');
    }

    // 2. Fix images — add alt text to decorative/informative images
    var images = modal.querySelectorAll('img');
    images.forEach(function(img) {
      var currentAlt = (img.getAttribute('alt') || '').trim();
      var signature = ((img.getAttribute('src') || '') + ' ' + (img.className || '') + ' ' + currentAlt).toLowerCase();

      if (/melinda|logo/.test(signature) && (!currentAlt || /^logo$/i.test(currentAlt))) {
        img.setAttribute('alt', "Melinda's Foods logo");
        img.removeAttribute('role');
        return;
      }

      if (!img.hasAttribute('alt')) {
        // Check if image is decorative (small, background-like) or informative
        var isDecorative = img.width < 50 || img.height < 50 ||
          (img.className && /decorat|bg|background|icon/i.test(img.className));
        if (isDecorative) {
          img.setAttribute('alt', '');
          img.setAttribute('role', 'presentation');
        } else {
          img.setAttribute('alt', 'Promotional offer image');
        }
      }
    });

    // 3. Fix form labels
    var inputs = modal.querySelectorAll('input:not([type="hidden"]):not([type="submit"])');
    inputs.forEach(function(input, i) {
      if (!input.id) input.id = 'alia-input-' + i;

      var hasLabel = modal.querySelector('label[for="' + input.id + '"]');
      if (!hasLabel && !input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
        var placeholder = input.getAttribute('placeholder');
        var type = input.getAttribute('type') || 'text';

        var labelText = placeholder || (type === 'email' ? 'Email address' : 'Enter value');
        input.setAttribute('aria-label', labelText);
      }

      // Add aria-required if it looks required
      if (input.hasAttribute('required') && !input.getAttribute('aria-required')) {
        input.setAttribute('aria-required', 'true');
      }
    });

    // 4. Fix close button
    var closeButtons = modal.querySelectorAll(
      '[class*="close"], [onclick*="close"], button:not([aria-label])'
    );
    closeButtons.forEach(function(btn) {
      var text = (btn.textContent || '').trim();
      if (text === '' || text === 'x' || text === 'X' || text === '\u00D7') {
        btn.setAttribute('aria-label', 'Close promotional offer');
      }
      if (btn.tagName !== 'BUTTON') {
        btn.setAttribute('role', 'button');
        if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');
      }
      // Ensure Space key triggers close button (AV-99 issue #5)
      btn.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.keyCode === 32) {
          e.preventDefault();
          btn.click();
        }
      });
      // Also ensure Enter key works
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          btn.click();
        }
      });
    });

    // 5. Fix duplicate IDs
    var allIds = {};
    modal.querySelectorAll('[id]').forEach(function(el) {
      if (allIds[el.id]) {
        el.id = el.id + '-' + Math.random().toString(36).substr(2, 4);
      }
      allIds[el.id] = true;
    });

    // 6. Add live region for status messages
    var existingLive = modal.querySelector('[aria-live]');
    if (!existingLive) {
      var liveRegion = document.createElement('div');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'sr-only';
      liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
      modal.appendChild(liveRegion);
      modal._a11yLiveRegion = liveRegion;
    }

    // 7. Announce errors to screen readers
    var form = modal.querySelector('form');
    if (form) {
      form.setAttribute('novalidate', '');
      form.addEventListener('submit', function(e) {
        var invalidInputs = modal.querySelectorAll('input:invalid');
        invalidInputs.forEach(function(inp) {
          inp.setAttribute('aria-invalid', 'true');

          var errorId = inp.id + '-error';
          var existingError = document.getElementById(errorId);
          if (!existingError) {
            var errorMsg = document.createElement('span');
            errorMsg.id = errorId;
            errorMsg.className = 'alia-a11y-error';
            errorMsg.setAttribute('role', 'alert');
            errorMsg.textContent = 'This field is required';
            errorMsg.style.cssText = 'color:#c00;font-size:14px;display:block;margin-top:4px;';
            inp.parentNode.insertBefore(errorMsg, inp.nextSibling);
            inp.setAttribute('aria-describedby', errorId);
          }
        });

        if (invalidInputs.length > 0 && modal._a11yLiveRegion) {
          modal._a11yLiveRegion.textContent = invalidInputs.length + ' field(s) need attention';
        }
      });
    }
  }

  // Keyboard: Escape to close, tab trapping
  function setupKeyboardHandlers(modal) {
    document.addEventListener('keydown', function(e) {
      var currentModal = getModal();
      if (!currentModal || currentModal.offsetParent === null) return;

      // Escape to close
      if (e.key === 'Escape' || e.keyCode === 27) {
        var closeBtn = currentModal.querySelector(
          '[class*="close"], [aria-label*="close"], [aria-label*="Close"]'
        );
        if (closeBtn) {
          closeBtn.click();
          e.preventDefault();
        }
      }

      // Tab trapping
      if (e.key === 'Tab' || e.keyCode === 9) {
        var focusable = currentModal.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length === 0) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });
  }

  // Focus management when modal opens
  function setupFocusManagement() {
    var previousFocus = null;
    var modalWasOpen = false;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Check for modal appearing
        var modal = getModal();
        if (modal && modal.offsetParent !== null) {
          fixModalA11y(modal);
          modalWasOpen = true;

          if (!previousFocus) {
            previousFocus = document.activeElement;
          }

          // Focus the first focusable element
          var firstFocusable = modal.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          if (firstFocusable) {
            setTimeout(function() { firstFocusable.focus(); }, 100);
          }
        }

        // Check for modal disappearing — return focus
        if ((!modal || modal.offsetParent === null) && modalWasOpen) {
          if (canRestoreFocus(previousFocus, modal)) {
            previousFocus.focus();
          }
          previousFocus = null;
          modalWasOpen = false;
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupKeyboardHandlers();
      setupFocusManagement();
      // Fix if modal already in DOM
      var existing = getModal();
      if (existing) fixModalA11y(existing);
    });
  } else {
    setupKeyboardHandlers();
    setupFocusManagement();
    var existing = getModal();
    if (existing) fixModalA11y(existing);
  }
})();

/* ============================================================
   AV-99: Additional promo modal hardening for April 2026 retest
   ============================================================ */
(function() {
  'use strict';

  // Disabled during emergency rollback. This block mutates DOM state while
  // observing the same subtree, which can lock the page.
  return;

  var MODAL_SELECTORS = '[data-alia-modal], .alia-popup, .alia-modal, [id^="alia-root-"], [id^="alia-popup-root-"], [role="dialog"][aria-label*="Alia"]';
  var COOKIE_SELECTORS = '.shopify-pc__banner, #shopify-pc__banner, [id*="cookie-banner"], [class*="cookie-banner"], .shopify-privacy-banner';
  var COOKIE_PREFS_SELECTORS = '#shopify-pc__prefs, #shopify-pc__prefs__dialog';
  var PROMO_ROOT_SELECTORS = '[data-alia-modal], .alia-popup, .alia-modal, [id^="alia-root-"], [id^="alia-popup-root-"]';
  var activeModal = null;
  var previousFocus = null;
  var lastStepLabel = '';
  var lastInputModality = 'pointer';
  var promoDismissed = false;
  var activeCloseModalId = '';

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function isCookieBannerContainer(el) {
    if (!el) return false;
    if (el.id === 'shopify-pc__banner') return true;
    if (typeof el.className === 'string' && el.className.indexOf('shopify-pc__banner') !== -1) return true;
    if (!/^(SECTION|DIV|ASIDE)$/i.test(el.tagName)) return false;
    return !!el.querySelector('button, a, input, [role="button"]');
  }

  function isCookiePrefsContainer(el) {
    if (!el) return false;
    return el.id === 'shopify-pc__prefs' || el.id === 'shopify-pc__prefs__dialog';
  }

  function getVisiblePromoRoot() {
    var promoRoots = document.querySelectorAll(PROMO_ROOT_SELECTORS);
    for (var i = 0; i < promoRoots.length; i += 1) {
      var root = promoRoots[i];
      if (root.dataset && root.dataset.a11yDismissed === 'true') continue;
      if (isVisible(root)) return root;
    }
    return promoRoots[0] || null;
  }

  function getCloseTargetFromElement(el) {
    if (!el || !el.closest) return null;
    return (
      el.closest(PROMO_ROOT_SELECTORS) ||
      el.closest(MODAL_SELECTORS)
    );
  }

  function getVisibleModal() {
    var modals = document.querySelectorAll(MODAL_SELECTORS);
    for (var i = 0; i < modals.length; i += 1) {
      if (isVisible(modals[i])) return modals[i];
    }
    return getVisiblePromoRoot();
  }

  function getPromoRoots() {
    return document.querySelectorAll(PROMO_ROOT_SELECTORS);
  }

  function getA11yCloseButton() {
    var button = document.querySelector('[data-a11y-promo-close="true"]');
    if (button) return button;

    button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('aria-label', 'Close popup');
    button.setAttribute('data-a11y-promo-close', 'true');
    button.textContent = '×';
    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      var modal = getVisibleModal();
      if (!modal) {
        removeA11yCloseButton();
        return;
      }

      var nativeClose = findNativeCloseControl(modal);
      if (nativeClose && nativeClose !== button && typeof nativeClose.click === 'function') {
        nativeClose.click();
      }

      window.setTimeout(function() {
        var currentModal = getCloseTargetFromElement(button) || getVisibleModal() || getVisiblePromoRoot();
        if (currentModal) {
          dismissPromo(currentModal);
        } else {
          removeA11yCloseButton();
        }
      }, 60);
    }, true);

    document.body.appendChild(button);
    return button;
  }

  function isCloseCandidate(el) {
    if (!el || !el.closest) return false;
    var candidate = el.closest('[data-a11y-promo-close="true"], [aria-label], [class*="close"], [id*="close"]');
    if (!candidate) return false;
    if (!isVisible(candidate)) return false;
    if (!candidate.closest(PROMO_ROOT_SELECTORS)) return false;
    if (candidate.getAttribute('data-a11y-promo-close') === 'true') return true;

    return isCloseControl(candidate);
  }

  function hidePromoRoot(root) {
    if (!root) return;
    root.dataset.a11yDismissed = 'true';
    root.setAttribute('aria-hidden', 'true');
    root.inert = true;
    root.style.setProperty('display', 'none', 'important');
  }

  function removeA11yCloseButton() {
    var button = document.querySelector('[data-a11y-promo-close="true"]');
    if (button) button.remove();
    activeCloseModalId = '';
  }

  function findNativeCloseControl(modal) {
    if (!modal) return null;

    var candidates = modal.querySelectorAll('[aria-label], [class*="close"], [id*="close"], [role="button"], button, a');
    for (var i = 0; i < candidates.length; i += 1) {
      if (!isVisible(candidates[i])) continue;
      if (isCloseControl(candidates[i])) return candidates[i];
    }

    return null;
  }

  function positionA11yCloseButton(modal) {
    if (!modal || !isVisible(modal)) {
      removeA11yCloseButton();
      return;
    }

    var button = getA11yCloseButton();
    var nativeClose = findNativeCloseControl(modal);
    var modalRect = modal.getBoundingClientRect();
    var rect = nativeClose ? nativeClose.getBoundingClientRect() : modalRect;
    var size = nativeClose
      ? Math.max(48, Math.min(64, Math.round(Math.max(rect.width, rect.height))))
      : 48;
    var top = nativeClose ? rect.top : modalRect.top + 16;
    var left = nativeClose ? rect.left : modalRect.right - size - 16;

    if (nativeClose) {
      nativeClose.dataset.a11yNativeClose = 'true';
      activeCloseModalId = ensureId(modal, 'alia-modal');
    }

    button.style.top = Math.max(12, Math.round(top)) + 'px';
    button.style.left = Math.max(12, Math.round(left)) + 'px';
    button.style.width = size + 'px';
    button.style.height = size + 'px';
    button.style.display = 'flex';
  }

  function shouldRestoreFocus() {
    return lastInputModality === 'keyboard';
  }

  function getText(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function ensureId(el, fallback) {
    if (!el.id) {
      el.id = fallback + '-' + Math.random().toString(36).slice(2, 8);
    }
    return el.id;
  }

  function addKeyboardActivation(el) {
    if (!el || el.dataset.a11yExtraBound) return;
    el.dataset.a11yExtraBound = 'true';
    el.addEventListener('keydown', function(e) {
      if (e.key === ' ' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        el.click();
      }
    });
  }

  function isCloseControl(el) {
    var descriptor = (
      (el.getAttribute('aria-label') || '') + ' ' +
      (el.id || '') + ' ' +
      (typeof el.className === 'string' ? el.className : '') + ' ' +
      getText(el)
    ).toLowerCase();
    return /close popup|close promotional offer|dismiss|close|×/.test(descriptor);
  }

  function dismissPromo(modal) {
    promoDismissed = true;
    removeA11yCloseButton();
    var target = getCloseTargetFromElement(modal) || getVisiblePromoRoot() || getVisibleModal();
    var roots = getPromoRoots();

    if (target) {
      hidePromoRoot(target);
    } else if (roots.length) {
      roots.forEach(function(root) {
        hidePromoRoot(root);
      });
    }

    suppressCookieBanner(false);

    if (shouldRestoreFocus()) {
      var skipLink = document.querySelector('a.skip-to-content[href="#MainContent"]');
      if (skipLink) {
        skipLink.focus();
      } else if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    activeModal = null;
    previousFocus = null;
    lastStepLabel = '';
  }

  function bindCloseBehavior(el, modal) {
    if (!el || el.dataset.a11yCloseBound || !isCloseControl(el)) return;
    el.dataset.a11yCloseBound = 'true';
    el.setAttribute('aria-label', el.getAttribute('aria-label') || 'Close popup');

    el.addEventListener('click', function() {
      window.setTimeout(function() {
        var currentModal = getCloseTargetFromElement(el) || getVisiblePromoRoot() || getVisibleModal();
        if (currentModal) {
          dismissPromo(currentModal);
        }
      }, 90);
    });
  }

  function getHeading(modal) {
    var candidates = modal.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, [role="heading"], [class*="title"], [class*="heading"], [class*="headline"]'
    );

    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      var text = getText(candidate);
      if (!isVisible(candidate) || !text) continue;
      if (/try your luck|mystery discount|you\'re in|you’re in|claim/i.test(text)) {
        return candidate;
      }
    }

    for (var j = 0; j < candidates.length; j += 1) {
      if (isVisible(candidates[j]) && getText(candidates[j])) return candidates[j];
    }

    return null;
  }

  function getLiveRegion(modal) {
    var region = modal.querySelector('[data-a11y-modal-live]');
    if (!region) {
      region = document.createElement('div');
      region.className = 'sr-only';
      region.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      region.setAttribute('data-a11y-modal-live', 'true');
      modal.appendChild(region);
    }
    return region;
  }

  function announce(modal, message) {
    if (!message) return;
    var region = getLiveRegion(modal);
    region.textContent = '';
    window.setTimeout(function() {
      region.textContent = message;
    }, 30);
  }

  function ensureHeadingAndFocus(modal) {
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    var heading = getHeading(modal);
    if (heading) {
      if (!/^H[1-6]$/.test(heading.tagName) && !heading.getAttribute('role')) {
        heading.setAttribute('role', 'heading');
        heading.setAttribute('aria-level', '2');
      }
      modal.setAttribute('aria-labelledby', ensureId(heading, 'alia-modal-title'));
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    } else {
      modal.setAttribute('aria-label', 'Promotional offer');
      modal.setAttribute('tabindex', '-1');
    }

    var currentStep = heading ? getText(heading) : '';
    if (currentStep && currentStep !== lastStepLabel) {
      lastStepLabel = currentStep;
      announce(modal, currentStep);
      window.setTimeout(function() {
        (heading || modal).focus();
        if (typeof (heading || modal).scrollIntoView === 'function') {
          (heading || modal).scrollIntoView({ block: 'start', inline: 'nearest' });
        }
      }, 80);
    }
  }

  function ensureVisibleLabels(modal) {
    var fields = modal.querySelectorAll('input, select, textarea');
    fields.forEach(function(field, index) {
      var type = (field.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'checkbox' || type === 'radio') return;

      if (!field.id) field.id = 'alia-extra-field-' + index;
      var label = modal.querySelector('label[for="' + field.id + '"]');
      var labelText = field.getAttribute('placeholder') || (/tel|phone/i.test(field.name || '') ? 'Phone number' : type === 'email' ? 'Email address' : 'Input');

      if (!label) {
        label = document.createElement('label');
        label.className = 'alia-a11y-label';
        label.setAttribute('for', field.id);
        label.textContent = labelText;
        field.parentNode.insertBefore(label, field);
      } else if (!getText(label)) {
        label.textContent = labelText;
      }

      if (!field.getAttribute('aria-label') && !field.getAttribute('aria-labelledby')) {
        field.setAttribute('aria-label', labelText);
      }
    });
  }

  function fixImages(modal) {
    modal.querySelectorAll('img').forEach(function(img) {
      var currentAlt = (img.getAttribute('alt') || '').trim();
      var signature = ((img.getAttribute('src') || '') + ' ' + (img.className || '') + ' ' + currentAlt).toLowerCase();
      if (/melinda|logo/.test(signature) && (!currentAlt || /^logo$/i.test(currentAlt))) {
        img.setAttribute('alt', "Melinda's Foods logo");
        img.removeAttribute('role');
      }
    });

    modal.querySelectorAll('[class*="close"] svg, button svg, .icon-close').forEach(function(icon) {
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
      icon.setAttribute('role', 'presentation');
    });

    modal.querySelectorAll('[aria-label], [class*="close"], [id*="close"], [role="button"]').forEach(function(el) {
      if (isCloseControl(el)) {
        el.setAttribute('aria-label', el.getAttribute('aria-label') || 'Close popup');
      }
    });
  }

  function fixInteractiveElements(modal) {
    if (!modal.dataset.a11yCloseCaptureBound) {
      modal.dataset.a11yCloseCaptureBound = 'true';
      modal.addEventListener('click', function(event) {
        var target = event.target && event.target.closest
          ? event.target.closest('[aria-label], [class*="close"], [id*="close"], [data-a11y-promo-close="true"]')
          : null;
        if (!target || !isCloseControl(target)) return;
        window.setTimeout(function() {
          var currentModal = getCloseTargetFromElement(target) || getVisiblePromoRoot() || getVisibleModal();
          if (currentModal) {
            dismissPromo(currentModal);
          }
        }, 90);
      }, true);
    }

    modal.querySelectorAll('[onclick], [class*="btn"], [class*="button"], [class*="claim"], [class*="scratch"], [aria-label], [class*="close"], [id*="close"], [role="button"]').forEach(function(el) {
      if (!isVisible(el)) return;
      if (!/^(BUTTON|A|INPUT)$/.test(el.tagName)) {
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      }
      addKeyboardActivation(el);
      bindCloseBehavior(el, modal);
    });

    positionA11yCloseButton(modal);
  }

  function suppressCookieBanner(shouldSuppress) {
    document.querySelectorAll(COOKIE_SELECTORS).forEach(function(banner) {
      if (!isCookieBannerContainer(banner)) return;
      if (shouldSuppress && isVisible(banner)) {
        banner.setAttribute('aria-hidden', 'true');
        banner.inert = true;
      } else if (!shouldSuppress && banner.inert) {
        banner.removeAttribute('aria-hidden');
        banner.inert = false;
      }
    });
  }

  function hasVisibleCookieUi() {
    var elements = document.querySelectorAll(COOKIE_SELECTORS + ', ' + COOKIE_PREFS_SELECTORS);
    for (var i = 0; i < elements.length; i += 1) {
      var element = elements[i];
      if (!isVisible(element)) continue;
      if (isCookieBannerContainer(element) || isCookiePrefsContainer(element)) return true;
    }
    return false;
  }

  function suppressPromoForCookie(shouldSuppress) {
    getPromoRoots().forEach(function(root) {
      if (shouldSuppress) {
        removeA11yCloseButton();
        if (root.dataset.a11yDismissed === 'true') return;
        if (root.dataset.a11ySuppressedForCookie === 'true') return;
        root.dataset.a11ySuppressedForCookie = 'true';
        root.setAttribute('aria-hidden', 'true');
        root.inert = true;
        root.style.setProperty('display', 'none', 'important');
      } else if (root.dataset.a11ySuppressedForCookie === 'true') {
        if (root.dataset.a11yDismissed === 'true') return;
        root.removeAttribute('aria-hidden');
        root.inert = false;
        root.style.removeProperty('display');
        delete root.dataset.a11ySuppressedForCookie;
      }
    });
  }

  function handleModal() {
    if (promoDismissed) {
      getPromoRoots().forEach(function(root) {
        if (root.dataset.a11yDismissed === 'true') {
          root.setAttribute('aria-hidden', 'true');
          root.inert = true;
          root.style.setProperty('display', 'none', 'important');
        }
      });
      suppressCookieBanner(false);
      activeModal = null;
      previousFocus = null;
      lastStepLabel = '';
      removeA11yCloseButton();
      return;
    }

    if (hasVisibleCookieUi()) {
      suppressPromoForCookie(true);
      activeModal = null;
      lastStepLabel = '';
      removeA11yCloseButton();
      return;
    }

    suppressPromoForCookie(false);

    var modal = getVisibleModal();
    if (modal && isVisible(modal)) {
      if (activeModal !== modal) {
        activeModal = modal;
        previousFocus = document.activeElement;
        lastStepLabel = '';
      }
      suppressCookieBanner(true);
      ensureHeadingAndFocus(modal);
      ensureVisibleLabels(modal);
      fixImages(modal);
      fixInteractiveElements(modal);
      positionA11yCloseButton(modal);
      return;
    }

    if (activeModal) {
      suppressCookieBanner(false);
      if (shouldRestoreFocus()) {
        var skipLink = document.querySelector('a.skip-to-content[href="#MainContent"]');
        if (skipLink) {
          skipLink.focus();
        } else if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      }
    }

    activeModal = null;
    previousFocus = null;
    lastStepLabel = '';
    removeA11yCloseButton();
  }

  function observeModal() {
    handleModal();
    var observer = new MutationObserver(handleModal);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeModal);
  } else {
    observeModal();
  }

  document.addEventListener('keydown', function(e) {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (e.key === 'Escape' || e.keyCode === 27) {
      var currentModal = getCloseTargetFromElement(document.activeElement) || getVisiblePromoRoot() || getVisibleModal();
      if (currentModal && isVisible(currentModal)) {
        e.preventDefault();
        dismissPromo(currentModal);
      }
    }
    lastInputModality = 'keyboard';
  }, true);

  ['mousedown', 'pointerdown', 'touchstart'].forEach(function(eventName) {
    document.addEventListener(eventName, function() {
      lastInputModality = 'pointer';
    }, true);
  });

  ['mousedown', 'pointerdown', 'touchstart'].forEach(function(eventName) {
    document.addEventListener(eventName, function(event) {
      if (!event || event.defaultPrevented) return;
      var closeTarget = event.target && event.target.closest
        ? event.target.closest('[data-a11y-promo-close="true"]')
        : null;
      if (!closeTarget) return;
      var currentModal = getCloseTargetFromElement(closeTarget) || getVisiblePromoRoot() || getVisibleModal();
      if (!currentModal) return;
      event.preventDefault();
      event.stopPropagation();
      dismissPromo(currentModal);
    }, true);
  });

  window.addEventListener('resize', function() {
    var modal = getVisibleModal();
    if (modal) positionA11yCloseButton(modal);
  });

  window.addEventListener('scroll', function() {
    var modal = getVisibleModal();
    if (modal) positionA11yCloseButton(modal);
  }, true);
})();
